<template>
    <button
        v-if="visible"
        class="btn"
        :class="styles"
        :disabled="disabled"
        @click="click"
        v-tooltip="{text: tooltip}"
        @focus="focus">
        <slot name="left-icon"></slot>
        <slot />
        <slot name="right-icon"></slot>
    </button>
</template>
<script>
    export default {
        name: 'v-icon-button',
        props: {
            type: {
                type: String,
                default: null,
            },
            size: {
                type: String,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            // useful for dynamically show/hiding elements
            // created using a render function
            visible: {
                type: Boolean,
                default: true,
            },
            fluid: {
                type: Boolean,
                default: false,
            },
            tooltip: {
                type: String,
                default: null,
            },
            fitted: {
                type: Boolean,
                default: false,
            },
            tooltipRightEdge: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            styles() {
                const style = {};
                if (this.type) {
                    style[`btn-${this.type}`] = true;
                }
                if (this.size) {
                    let key;
                    if (this.size === 'small') {
                        key = 's';
                    } else if (this.size === 'large') {
                        key = 'l';
                    }
                    if (key) {
                        style[`btn-${key}`] = true;
                    }
                }
                if (this.fluid) {
                    style['btn-fluid'] = true;
                }
                if (this.fitted) {
                    style['btn-fitted'] = true;
                }
                // check if the slot is present to add the class
                // it requires
                if (this.$slots['left-icon']) {
                    style['has-icon-left'] = true;
                } else if (this.$slots['right-icon']) {
                    style['has-icon-right'] = true;
                } else {
                    style['has-icon'] = true;
                }
                return style;
            },
        },
        methods: {
            click($event) {
                this.$emit('click', $event);
            },
            focus($event) {
                this.$emit('focus', $event);
            },
        },
    };
</script>
